import { Model, Attr } from "spraypaint"
import ApplicationRecord from "./ApplicationRecord"

@Model()
class ApplicationRejectionReason extends ApplicationRecord {
  static jsonapiType = "application_rejection_reasons"

  @Attr() name: string
  @Attr() subReasons: { id: string; name: string }[];
}

export default ApplicationRejectionReason
